export enum ShmMessageType {
  general = 1,
  appointmentRequest = 2,
  prescriptionRenewal = 3
}
